import React from 'react';
import { Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getDocumentsV2 } from 'utils/DocumentsAPIUtils';
import { getFileIconClass, getDateFromObjectId, } from 'helpers/helper_functions';
import CargomaticSwitch from 'components/v2/Switch';
import formatMoney from 'utils/formatters/Money';
import { sluggify } from 'utils/localization/utils';
const LineItem = ({ handlePODClick, handleToggleSelect, onGroupItem, lineItem, chargeCountMap, shipmentId, selected, }) => {
    const [pod, setPod] = React.useState(null);
    const { t } = useTranslation();
    React.useEffect(() => {
        if (lineItem.category === 'base_cost' ||
            (lineItem.category === 'accessorials' &&
                lineItem.type === 'customer_adjustment')) {
            getShipmentPOD(shipmentId);
        }
    }, []);
    const getFileIcon = (key) => {
        const extension = key.split('.').pop().toUpperCase();
        return getFileIconClass(extension);
    };
    const getShipmentPOD = async (shipment_id) => {
        var _a;
        const { data } = await getDocumentsV2([shipment_id], null, {
            order: {
                field: 'createdAt',
                direction: 'desc',
            },
            limit: 1,
        });
        const documents = ((_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents) || [];
        const pods = documents.filter((doc) => doc.type === 'proof_of_delivery');
        const pocs = documents.filter((doc) => doc.type === 'proof_of_pickup');
        const docs = pods.length ? pods : pocs;
        setPod(docs[0] || null);
    };
    return (React.createElement("div", { className: "flex flex-wrap items-center justify-between mb-4", key: lineItem._id },
        React.createElement("div", { className: "flex flex-wrap items-center w-full md:w-4/5" },
            React.createElement("input", { type: "checkbox", className: "leading-tight form-field", disabled: !lineItem.equipment, onChange: handleToggleSelect(lineItem), checked: selected.includes(lineItem._id) }),
            React.createElement("div", { className: "flex items-center justify-between w-full ml-4 mr-2 md:w-4/5" },
                React.createElement("div", { className: "flex w-2/3 items-center justify-between" },
                    React.createElement("span", { className: "text-grey-dark" }, t(sluggify(lineItem.message))),
                    pod && (React.createElement("span", null,
                        React.createElement("a", { onClick: handlePODClick(pod.key), target: "_blank" },
                            React.createElement(OverlayTrigger, { placement: "top", overlay: React.createElement(Tooltip, null, t('ATTACHED_WITH_VALUE', {
                                    value: moment(pod.created_at).format('L LT'),
                                })) },
                                React.createElement("i", { className: getFileIcon(pod.key) }))))),
                    React.createElement("div", null,
                        lineItem.orphaned && (React.createElement("div", { className: "inline" },
                            React.createElement("span", { className: "flex justify-center inline-block w-full px-2 py-1 ml-4 text-xs font-bold text-red-800 rounded bg-red-50" },
                                t('MISMATCH'),
                                React.createElement(OverlayTrigger, { placement: "right", overlay: React.createElement(Tooltip, { style: { zIndex: 100011 } }, t('LINE_ITEM_EQUIPMENT_NO_LONGER_PRESENT')) },
                                    React.createElement(Glyphicon, { glyph: "info-sign", className: "px-1 text-sm text-red-700" }))))),
                        lineItem.equipment && (React.createElement("span", { className: "flex justify-center inline-block w-full px-2 py-1 ml-4 text-xs font-bold text-white rounded bg-green" }, lineItem.equipment)),
                        !lineItem.orphaned && !lineItem.equipment && (React.createElement("span", { className: "flex justify-center inline-block w-full px-2 py-1 ml-4 text-xs font-bold text-red-800 rounded bg-red-50" }, t('UNAPPLIED'))))),
                chargeCountMap[lineItem.type] > 1 && (React.createElement("div", { className: "flex w-1/4 font-semibold ml-4" },
                    React.createElement("p", { className: "mr-2 my-auto" }, t('GROUP')),
                    React.createElement(CargomaticSwitch, { className: "my-auto", disabled: !selected.includes(lineItem._id), height: 16, width: 32, uncheckedIcon: false, checkedIcon: false, checked: lineItem.grouped, onChange: (groupCharge) => onGroupItem(groupCharge, lineItem) }))))),
        React.createElement("span", { className: "ml-4 text-lg text-grey-dark" }, formatMoney(lineItem.value, lineItem === null || lineItem === void 0 ? void 0 : lineItem.currency))));
};
export default LineItem;
